"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const storm_ui_1 = require("@amzn/storm-ui");
const RegionSwitcherContent_1 = __importDefault(require("../RegionSwitcherContent/RegionSwitcherContent"));
const RegionSwitcherSelectorPopper = ({ id, isOpen, onClick, onClose, onSelect, trigger, children, }) => {
    return ((0, jsx_runtime_1.jsx)(storm_ui_1.Popper, { align: "start", autoFocus: true, position: "bottom", isOpen: isOpen, padding: "none", spacing: -31, withArrow: false, onClick: onClick, onCloseButtonClick: onClose, trigger: react_1.default.cloneElement(trigger, {
            ...trigger.props,
            'aria-haspopup': 'dialog',
            'aria-controls': `${id}`,
            'aria-expanded': isOpen,
            id: `${id}-trigger`,
        }), children: (0, jsx_runtime_1.jsx)(RegionSwitcherContent_1.default, { id: id, onClose: onClose, onSelect: onSelect, children: children }) }));
};
exports.default = RegionSwitcherSelectorPopper;
//# sourceMappingURL=RegionSwitcherSelectorPopper.js.map